<template>
  <div class="floatBox">
    <div class="float">
      <div class="z_btn z_btn0">
        <!-- <a target=_blank href="http://www.tseal.cn/tcloud/common.xhtml?projId=324"> -->
        <a target=_blank href="https://ygcg.jslink.com">
          <img src="../../assets/img/SC.png">
          <span>小E商城</span>
        </a>
        <!-- <a target=_blank href="https://ygcg.jslink.com">
          <img src="../../assets/img/SC.png">
          小E商城
        </a> -->
      </div>
      <div class="z_btn z_btn1">
        <!-- <a target=_blank href="http://www.tseal.cn/tcloud/common.xhtml?projId=324"> -->
        <a target=_blank href="https://ygcg.sxjypt.com/detail?articleId=298">
          <img src="../../assets/img/编组(1).png">
          <span>CA办理</span>
        </a>
      </div>
      <div :class="NavName == '资料下载' ? 'z_btn z_btn2 z_btn_selected' : 'z_btn z_btn2'">
        <router-link to="/list?type=0&class=6&categoryId=07">
          <img src="../../assets/img/编组.png">
          <span>资料下载</span>
        </router-link>
      </div>
      <div :class="NavName == '常见问题' ? 'z_btn z_btn3 z_btn_selected' : 'z_btn z_btn3'">
        <router-link to="/list?type=0&class=5&categoryId=04">
          <img src="../../assets/img/编组(2).png">
          <span>常见问题</span>
        </router-link>
      </div>
      <div :class="NavName == '会员信息管理' ? 'z_btn z_btn3 z_btn_selected' : 'z_btn z_btn3'">
        <a target=_blank href="/wstb/login.html?systemName=单位信息管理">
          <img src="../../assets/img/会员.png">
          <span>会员管理</span>
        </a>
      </div>
      <div class="z_btn z_btn5" @click="goTop()">
          <img src="../../assets/img/编组(4).png">
          <span>回到顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  computed: {
    NavName () {
      return this.$store.state.nav.navName
    }
  },
  methods: {
    goTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.z_btn{
    height: 92px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 144px;
    position: relative;
    cursor: pointer;
}
.z_btn5:before{
    content: '';
    position: absolute;
    left: 7.5%;
    bottom: 0px;
    width: 85%;
    height: 0px!important;
    background-color: #FFFFFF;
}
.z_btn:before{
    content: '';
    position: absolute;
    left: 7.5%;
    bottom: 0px;
    width: 85%;
    height: 1px;
    background-color: #FFFFFF;
}
.z_btn>a>img,.z_btn5>img{
    position: relative;
    top: -22px;
    right: 0px;
    width: 40px;
}
.z_btn>a>span,.z_btn5>span{
    display: inline-block;
    position: relative;
    top: -144px;
    color: #000;
}
.z_btn:hover>a>span,.z_btn5:hover>span{
    color: #fff;
}

.z_btn:hover img{
    filter:brightness(0) invert(1);
}
.z_btn:hover{
  background: #2485E7;
}
.z_btn0{
  background: #2485E7;
}
.z_btn0 span{
  color: #fff!important;
}
/* .z_btn:hover{
    background: #F45831;
}
.z_btn_selected{
    background: #F45831;
} */
.float{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/FloatBtn/FloatBtn.vue